<template>
    <div class="OrderComments">
        <slot v-bind="this"></slot>
    </div>
</template>

<script>
    import Page from '../../../mixins/PageComponent';
    import axios from 'axios';

    export default {
        extends: Page,
        data() {
            return {
                formVisible: false,
                error: '',
                messages: [],
                text: this.data.text || '',
                loading: false
            }
        },
        methods: {
            showForm() {
                this.formVisible = true;
            },
            hideForm() {
                this.formVisible = false;
                this.error = '';
                this.text = '';
            },
            handleTextInput(e) {
                this.text = e.target.value;
            },
            async submit(e) {
                let { action } = e.target;
                this.loading = true;
                try {
                    let response = await axios.post(action, { text:this.text });
                    this.messages.push(response.data);
                    this.hideForm();
                }
                catch(error) {
                    if(error.response.status === 422) {
                        this.error = error.response.data.errors.text[0];
                    }
                }
                finally {
                    this.loading = false;
                }
            }
        }
    }
</script>